module.exports = __webpack_public_path__ + "img/scheduling.a8b71789.svg";